import { Box } from "@mui/material";
import "./style";
import Grid from "@mui/material/Grid2";
import {
  StyleBoxMain,
  StyledBoxWidth,
  StyledGrid,
  StyledGridContainer,
} from "./style";
import Logo from "../../../assets/images/nativeLogo.png";
import AuthImage from "../../../components/common/auth/AuthImage";
import LoginForm from "../../../components/auth/login/LoginForm";
import { cookie } from "../../../cookies/cookies";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { LOGIN } from "../../../actions/AuthActions";

const Login = () => {
  const token = cookie.get("token");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const submitLock = useRef(false);
  const isSubmitting = useSelector((state) => state?.auth?.isLoading);
  const profileDetails = useSelector((state) => state?.auth?.profileDetails);
  const isAdmin = profileDetails.user_type === "admin";

  const handleLogin = (values) => {
    if (submitLock.current || isSubmitting) return;
    submitLock.current = true;

    const { emailOrPhone, password } = values;
    dispatch({
      type: LOGIN,
      payload: {
        emailOrPhone,
        password,
        onError: () => {
          submitLock.current = false;
        },
      },
    });
  };
  useEffect(() => {
    if (token) {
      if (isAdmin) {
        navigate("/admin/dashboard", { replace: true });
      } else {
        navigate("/dashboard", { replace: true });
      }
    }
  }, [token, isAdmin, navigate]);

return (
<>
      <StyleBoxMain>
        <StyledBoxWidth>
          <StyledGridContainer container>
            <Grid size={{ md: 7, xs: 0 }}>
              <AuthImage />
            </Grid>

            <StyledGrid size={{ md: 5, xs: 12 }}>
              <Box>
                <img loading="lazy" src={Logo} alt="Login Visual" />
              </Box>
              <LoginForm onSubmit={handleLogin} isSubmitting={isSubmitting} />
            </StyledGrid>
          </StyledGridContainer>
        </StyledBoxWidth>
      </StyleBoxMain>
    </>
  );
};

export default Login;
